import React from 'react';
import ImpactSlider from './ImpactSlider';

export default function Hero() {
  return (
    <section className="hero" id="accueil">
      <div className="blobs">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      <div className="hero-content">
        <div className="hero-badge">
          <span className="dot" />
          Agence IA nouvelle génération
        </div>

        <img src="/logo_without_name.png" alt="Geek AI" className="hero-logo" />

        <h1>
          Propulsez votre entreprise avec<br />
          <span className="g-text">l'Intelligence Artificielle</span>
        </h1>

        <p>
          Geek AI accompagne les entreprises dans leur transformation numérique grâce
          à des agents IA sur mesure, des publicités UGC générées par l'IA et des
          solutions web innovantes.
        </p>

        <div className="hero-btns">
          <a href="#contact" className="g-btn">Démarrer un projet</a>
          <a href="#services" className="outline-btn">Découvrir nos services</a>
        </div>

        <ImpactSlider />
      </div>
    </section>
  );
}
